import Circle from "./circle"

const BookedSlot = () => {
    return (
        <div>
            <Circle radius={5} borderColor="#3952D8" borderStyle="solid" backgroundColor="#3952D8" character="" />
        </div>
    )
}

export default BookedSlot;